export default __webpack_public_path__ + "static/media/player-katie-colour-mob.f53a713b.png";